import { render, staticRenderFns } from "./PlatformMenu.vue?vue&type=template&id=2dee5662&scoped=true"
import script from "./PlatformMenu.vue?vue&type=script&lang=ts"
export * from "./PlatformMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dee5662",
  null
  
)

export default component.exports